import { cn } from "@/lib/utils";

// Two-dimensional model: approval_status (pending/active/disabled/rejected)
// + runtime_status (online/offline). The optional legacy `status` values are
// kept as fallback for any older code path.
const COLOR = {
  // approval
  pending: "bg-status-pending",
  active: "bg-status-online",
  disabled: "bg-status-disabled",
  rejected: "bg-status-offline",
  // runtime
  online: "bg-status-online",
  offline: "bg-status-offline",
  // legacy
  new: "bg-status-pending",
  deleted: "bg-status-offline",
};

const LABEL = {
  pending: "En attente",
  active: "Actif",
  disabled: "Désactivé",
  rejected: "Refusé",
  online: "En ligne",
  offline: "Hors ligne",
  new: "Nouveau",
  deleted: "Supprimé",
};

export function StatusDot({ status, withLabel = false, className = "" }) {
  const color = COLOR[status] || "bg-status-disabled";
  const isLive = status === "online" || status === "active";
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <span className={cn("relative inline-block size-2 rounded-full", color, isLive && "pulse-dot")} />
      {withLabel && (
        <span className="overline text-zinc-300" data-testid={`status-label-${status}`}>
          {LABEL[status] || status}
        </span>
      )}
    </span>
  );
}
